<template>
  <div class="home-container" id="app"> <BackgroundParticles />
    
    <TheNavbar />

    <main class="main-content">
      <section class="hublot-wrapper">
        <TheHublot @command="handleCommand" />
      </section>
    
      <div id="about-me">
        <AboutMe />
      </div>

    <div id="skills">
      <SkillsSection />
    </div>
    
      <section id="projets" class="projects-section">
        <GithubFetcher />
      </section>

      <ContactSection /> 

      <TheFooter />
    </main>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import TheHublot from '../components/TheHublot.vue'
import AboutMe from '../components/AboutMe.vue' 
import TheNavbar from '../components/TheNavbar.vue'
import ContactSection from '../components/ContactSection.vue'
import SkillsSection from '../components/SkillsSection.vue'

const BackgroundParticles = defineAsyncComponent(() => 
  import('../components/BackgroundParticles.vue')
)
const GithubFetcher = defineAsyncComponent(() => 
  import('../components/GithubFetcher.vue')
)
const TheFooter = defineAsyncComponent(() => 
  import('../components/TheFooter.vue')
)

const handleCommand = (cmd) => {
  console.log(`[System] Command received: ${cmd}`)
}
</script>

<style scoped>
/* --- MISE EN PAGE GLOBALE DE LA VUE --- */
.home-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.main-content {
  max-width: 1000px; /* Largeur contenue pour la lisibilité */
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1; /* Passe devant les particules */
  
  /* Animation d'entrée douce */
  animation: pageLoad 0.8s ease-out;
}

@keyframes pageLoad {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* --- SECTION HUBLOT --- */
.hublot-wrapper {
  margin: 40px 0 60px;
  display: flex;
  justify-content: center;
}

/* --- SECTION PROJETS (Style Tech) --- */
.projects-section {
  margin-bottom: 80px;
}

.section-header {
  margin-bottom: 30px;
  border-left: 3px solid var(--text-primary, #050505); /* Ligne verticale noire */
  padding-left: 20px;
}

.section-title {
  font-family: 'Space Mono', monospace; /* Assure-toi d'avoir importé la police dans App.vue ou index.html */
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 5px 0;
  letter-spacing: -1px;
  color: var(--text-primary, #050505);
}


.section-subtitle {
  font-family: 'Space Mono', monospace;
  color: #666; /* Gris moyen */
  font-size: 0.9rem;
  font-style: italic;
  margin: 0;
}

/* --- RESPONSIVE --- */
@media (max-width: 768px) {
  .hublot-wrapper {
    margin: 20px 0 40px;
  }
  
  .section-title {
    font-size: 1.4rem;
  }
}
</style>